import React from "react";
import DAFNTable from "./DAFNTable/DAFNTable";

export default function DAFNCard(props) {
    const { dafn_data } = props
    const hasSource = Object.keys(dafn_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                DAFN - Match encontrado
            </p>
            <DAFNTable dafn_data={dafn_data.source} />
        </div>
    )
}
